"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var IntegrationsUI_1 = __importDefault(require("./IntegrationsUI"));
var IntegrationsController = (function () {
    function IntegrationsController(make, user, account, rolesService, integrationService, $state, state) {
        this.integrationService = integrationService;
        this.state = state;
        var integrationsUI = make(IntegrationsUI_1.default, {
            controller: this,
            userHasAccess: function () {
                return rolesService.isAdmin(user);
            },
        });
        if (account.integrations == null) {
            account.integrations = {};
        }
        this.isIntegrationEnabled = integrationService.isEnabled;
        this.ui = integrationsUI.ui;
        if ($state.params.subsection) {
            integrationsUI.openIntegrationSettings($state.params.subsection);
        }
    }
    IntegrationsController.prototype.getIntegrationSettingsUI = function (integration) {
        var focus = this.integrationService.getIntegrationSettingsUI(integration);
        if (focus) {
            return focus.ui;
        }
    };
    IntegrationsController.prototype.goToIntegration = function (integrationUrlSafeName) {
        this.state.silentlyGo("settingsWithSubsection", {
            section: "integrations",
            subsection: integrationUrlSafeName,
        });
    };
    IntegrationsController.prototype.goToIntegrationsList = function () {
        this.state.silentlyGo("settings", {
            section: "integrations",
        });
    };
    return IntegrationsController;
}());
exports.default = IntegrationsController;
